

import { classesRuntime, statesRuntime } from "./../../stylable-esm-runtime.js";



var _namespace_ = "wds_1_220_2_breakpoints";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_220_2_breakpoints__root"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {"breakpoint-small":"490px","breakpoint-medium":"768px","breakpoint-large":"1186px","breakpoint-x-large":"1572px"}; 
export var vars = {}; 




